
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warehouse",
      function () {
        return require("private-next-pages/warehouse/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warehouse"])
      });
    }
  